module.exports = __webpack_public_path__ + "static/img/login-bg-ynzy.3cce6c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg-ynzy.jpg
// module id = i1uV
// module chunks = 1